const WECHAT_USER_AGENT_PATTERN = /MicroMessenger/i;

export const WECHAT_BIND_TICKET_KEY = 'wechat-bind-ticket';
export const WECHAT_OAUTH_SKIP_KEY = 'wechat-oauth-skip';

export function isWechatBrowser(userAgent = navigator.userAgent): boolean {
  return WECHAT_USER_AGENT_PATTERN.test(userAgent);
}

export function markWechatOAuthSkipped(): void {
  sessionStorage.setItem(WECHAT_OAUTH_SKIP_KEY, '1');
}

export function canAttemptWechatOAuth(): boolean {
  return isWechatBrowser() && sessionStorage.getItem(WECHAT_OAUTH_SKIP_KEY) !== '1';
}

export function buildWechatAuthorizeUrl(target: string): string {
  return `/api/auth/wechat/authorize?target=${encodeURIComponent(target)}`;
}
